import * as React from "react";
import PropTypes from "prop-types";

function LinkIcon(props) {
  const { className, height, width, color = "currentColor" } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 27.144 27.148"
    >
      <g id="link-Bold" transform="translate(-42.713 -42.687)">
        <path
          d="M67.885,54.179l-2.5,2.5a1.357,1.357,0,0,1-1.92-1.92l2.5-2.5a4.024,4.024,0,0,0,0-5.682,4.109,4.109,0,0,0-5.68,0l-4.56,4.56a2.756,2.756,0,0,0-.363.43,4,4,0,0,0,.363,5.254,1.358,1.358,0,0,1-1.921,1.92,6.673,6.673,0,0,1-.676-8.715,5.181,5.181,0,0,1,.675-.806l4.562-4.562a6.732,6.732,0,1,1,9.52,9.521Zm-11.04-.4a1.357,1.357,0,0,0,0,1.92,3.973,3.973,0,0,1,.934,4.205,3.83,3.83,0,0,1-.934,1.478l-4.56,4.56a4.109,4.109,0,0,1-5.68,0,4.024,4.024,0,0,1,0-5.682l2.5-2.5a1.357,1.357,0,0,0-1.92-1.92l-2.5,2.5a6.732,6.732,0,1,0,9.52,9.521l4.56-4.56a6.524,6.524,0,0,0,1.579-2.51,6.738,6.738,0,0,0-1.58-7.013,1.357,1.357,0,0,0-1.919,0Z"
          transform="translate(0 0)"
          fill={color}
        />
      </g>
    </svg>
  );
}

LinkIcon.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
};

export default LinkIcon;
